import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getDefaultRoute } from '../route-utils';

@Component({
  selector: 'initial-screen',
  templateUrl: './initial-screen.component.html',
  styleUrls: ['./initial-screen.component.scss']
})
export class InitialScreenComponent implements OnInit {

  constructor(private router: Router) { }

  routing(route: string) {
    this.router.navigate([route]);
  }

  ngOnInit() {
    const defaultPage = getDefaultRoute();
      this.routing(defaultPage || '/dashboard');
  }

}
